/* The customer's timezone does not change the warehouse's packing day. */
(() => {
  const zone = 'Europe/Stockholm';
  const partsFormatter = new Intl.DateTimeFormat('en-GB', {
    timeZone: zone, year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
  });
  const parts = now => Object.fromEntries(partsFormatter.formatToParts(now)
    .filter(part => part.type !== 'literal').map(part => [part.type, Number(part.value)]));
  const workday = date => date.getUTCDay() !== 0 && date.getUTCDay() !== 6;
  const nextDay = date => date.setUTCDate(date.getUTCDate() + 1);

  function estimate(now = new Date()) {
    const local = parts(now);
    const date = new Date(Date.UTC(local.year, local.month - 1, local.day));
    // At or after 10:00 the order joins the next weekday's packing batch.
    if (local.hour >= 10 || !workday(date)) nextDay(date);
    while (!workday(date)) nextDay(date);
    for (let remaining = 2; remaining > 0;) {
      nextDay(date);
      if (workday(date)) remaining -= 1;
    }
    return date.toISOString().slice(0, 10);
  }

  function nextCutoff(now = new Date()) {
    const local = parts(now);
    const wallClock = new Date(Date.UTC(local.year, local.month - 1, local.day, 10));
    if (local.hour >= 10) nextDay(wallClock);
    let instant = wallClock.getTime();
    // Resolve Stockholm wall time, including a change between CET and CEST.
    for (let i = 0; i < 3; i += 1) {
      const value = parts(new Date(instant));
      const represented = Date.UTC(value.year, value.month - 1, value.day, value.hour, value.minute, value.second);
      instant += wallClock.getTime() - represented;
    }
    return instant;
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { estimate, nextCutoff };
    return;
  }
  if (window.mettaV2DeliveryInitialized) return;
  window.mettaV2DeliveryInitialized = true;
  function mount(element) {
    if (element.v2DeliveryCleanup) return;
    const time = element.querySelector('time');
    const help = element.querySelector('.v2-delivery-help');
    help?.addEventListener('pointerenter', () => { if (matchMedia('(hover:hover)').matches) help.open = true; });
    help?.addEventListener('pointerleave', () => { if (!help.contains(document.activeElement)) help.open = false; });
    help?.addEventListener('keydown', event => { if (event.key === 'Escape') { help.open = false; help.querySelector('summary').focus(); } });
    let timer;
    function refresh() {
      clearTimeout(timer);
      if (!element.isConnected) return;
      const now = new Date();
      const iso = estimate(now);
      const locale = element.closest('[data-v2-pdp]')?.dataset.locale || document.documentElement.lang || 'sv';
      time.dateTime = iso;
      time.textContent = new Intl.DateTimeFormat(locale, {
        timeZone: 'UTC', weekday: 'long', day: 'numeric', month: 'long'
      }).format(new Date(`${iso}T12:00:00Z`));
      element.hidden = false;
      timer = setTimeout(refresh, Math.max(1000, nextCutoff(now) - now.getTime() + 50));
    }
    function resume() { if (!document.hidden) refresh(); }
    document.addEventListener('visibilitychange', resume);
    window.addEventListener('pageshow', refresh);
    element.v2DeliveryCleanup = () => {
      clearTimeout(timer);
      document.removeEventListener('visibilitychange', resume);
      window.removeEventListener('pageshow', refresh);
    };
    refresh();
  }
  const init = (scope = document) => scope.querySelectorAll('[data-v2-delivery-estimate]').forEach(mount);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-v2-delivery-estimate]').forEach(element => element.v2DeliveryCleanup?.()));
})();
